//@flow
import { HiverAxios, showMessage, setHiddenLoadingBar } from 'h-commons';
import { 
    GET_EXPORT_STATUS_INIT,
    GET_EXPORT_STATUS_DONE,
    GET_EXPORT_STATUS_FAILED,
    INITIATE_EXPORT_INIT,
    INITIATE_EXPORT_DONE,
    INITIATE_EXPORT_FAILED
} from './types';

export const getExportStatus = (hidden: boolean) => (dispatch: Function) => {
    dispatch({ type: GET_EXPORT_STATUS_INIT });
    hidden && dispatch(setHiddenLoadingBar(true))
    HiverAxios({
        url: '/api/account/export',
        type: 'GET',
        callback: response => {
            if (response.data && response.data.success) {
                dispatch({
                    type: GET_EXPORT_STATUS_DONE,
                    payload: response.data.data
                });
            } else 
                dispatch({
                    type: GET_EXPORT_STATUS_FAILED
                });
            hidden && dispatch(setHiddenLoadingBar(false))
        },
        onfail: () => {
            dispatch({
                type: GET_EXPORT_STATUS_FAILED
            })
            hidden && dispatch(setHiddenLoadingBar(false))
        }
    })
}

export const initiateExport = (exportData: Array<string>, email: string) => (dispatch: Function) => {
    dispatch({ type: INITIATE_EXPORT_INIT });
    HiverAxios({
        url: '/export/initiate',
        type: 'POST',
        params: {
            export_objects: exportData
        },
        callback: resp => {
            if (resp.data && resp.data.status === 'success') {
                dispatch({
                    type: INITIATE_EXPORT_DONE,
                    payload: { in_progress: 1, ...resp.data }
                });
                showMessage({
                    message:`An email will be sent to ${email} on export completion.`,
                    type:'info'
                });
            } else {
                dispatch({
                    type: INITIATE_EXPORT_FAILED
                });
                showMessage({
                    message:'Failed to initiate export.',
                    type:'error'
                });
            }
        }, onfail: () => {
            dispatch({
                type: INITIATE_EXPORT_FAILED
            });
            showMessage({
                message:'Failed to initiate export.',
                type:'error'
            });
        }
    })
}